// ---------- Tabs (delegation) ----------
const tabsWrap = document.querySelector(".tabs") || document;
const tabs  = [...document.querySelectorAll(".tab")];
const panes = [...document.querySelectorAll(".tab-pane")];

const tabByTarget = new Map(tabs.map(t => [t.dataset.target, t]));
const paneById    = new Map(panes.map(p => [p.id, p]));

function setActiveTab(targetId) {
  const nextTab  = tabByTarget.get(targetId);
  const nextPane = paneById.get(targetId);
  if (!nextTab || !nextPane) return;

  const curTab  = document.querySelector(".tab.active");
  const curPane = document.querySelector(".tab-pane.active");

  if (curTab)  curTab.classList.remove("active");
  if (curPane) curPane.classList.remove("active");

  nextTab.classList.add("active");
  nextPane.classList.add("active");
}

tabsWrap.addEventListener("click", (e) => {
  const tab = e.target.closest(".tab");
  if (!tab) return;
  setActiveTab(tab.dataset.target);
});

// ---------- Search + highlight ----------
const input    = document.getElementById("table-search");
const clearBtn = document.getElementById("clear-search");
if (!input || !clearBtn) return;

const groups = [...document.querySelectorAll("tbody.group")];
const rows = groups.flatMap(g => [...g.querySelectorAll("tr")]);

// Cache cells + original html + searchable text
const rowInfo = new Map();     // tr -> { tds, text }
const origHtml = new WeakMap(); // td -> html

for (const tr of rows) {
  const tds = [...tr.querySelectorAll("td")];
  const text = tds
    .filter(td => !td.classList.contains("photo-cell") && !td.querySelector("img"))
    .map(td => (td.textContent || "").toLowerCase())
    .join(" ");

  rowInfo.set(tr, { tds, text });
  for (const td of tds) if (!origHtml.has(td)) origHtml.set(td, td.innerHTML);
}

const DEBOUNCE = 200;
let t = 0;

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

function highlightTextNodes(node, re) {
  if (node.nodeType === Node.TEXT_NODE) {
    const text = node.nodeValue;
    let last = 0, m;
    re.lastIndex = 0;

    const frag = document.createDocumentFragment();
    while ((m = re.exec(text)) !== null) {
      if (m.index > last) frag.append(text.slice(last, m.index));
      const mark = document.createElement("mark");
      mark.className = "highlight";
      mark.textContent = m[0];
      frag.append(mark);
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.append(text.slice(last));
    if (frag.childNodes.length) node.replaceWith(frag);
    return;
  }
  // быстрее чем forEach на NodeList
  for (let c = node.firstChild; c; c = c.nextSibling) highlightTextNodes(c, re);
}

function restoreRow(tr) {
  const info = rowInfo.get(tr);
  if (!info) return;
  for (const td of info.tds) {
    const base = origHtml.get(td);
    if (base != null) td.innerHTML = base;
  }
}

function highlightRow(tr, queryLower) {
  const info = rowInfo.get(tr);
  if (!info) return;

  const re = new RegExp(`(${escapeRegExp(queryLower)})`, "gi");
  for (const td of info.tds) {
    if (td.classList.contains("photo-cell") || td.querySelector("img")) continue;

    // восстановим html перед новой подсветкой
    const base = origHtml.get(td);
    if (base != null) td.innerHTML = base;

    highlightTextNodes(td, re);
  }
}

function toggleClear() {
  clearBtn.hidden = !input.value.length;
}

// Zebra uses current DOM visibility state
function applyZebraByGroup() {
  let visibleIndex = 0;

  for (const group of groups) {
    if (group.style.display === "none" || group.hidden) continue;

    const even = (visibleIndex++ % 2) === 0;
    group.classList.toggle("zebra-even", even);
    group.classList.toggle("zebra-odd", !even);

    for (const tr of group.rows || group.querySelectorAll("tr")) {
      if (tr.style.display === "none" || tr.hidden) continue;
      tr.classList.toggle("zebra-even", even);
      tr.classList.toggle("zebra-odd", !even);
    }
  }
}

function applySearch() {
  const q = input.value.trim().toLowerCase();

  if (!q) {
    for (const tr of rows) {
      tr.style.display = "";
      restoreRow(tr);
    }
    applyZebraByGroup();
    return;
  }

  // фильтрация
  const visible = [];
  for (const tr of rows) {
    const { text } = rowInfo.get(tr) || { text: "" };
    const matchText = !q || text.includes(q);
    const matchStock = isInStock(tr) || tr === tr.closest("tbody.group")?.querySelector("tr"); 
    // ^ если тебе нужно оставлять первую строку ради фото — лучше обработать отдельно (см. ниже)

    const show = matchText && matchStock;
    tr.style.display = show ? "" : "none";
    if (show) visible.push(tr);
    else restoreRow(tr);
  }

  // подсветка только видимых
  requestAnimationFrame(() => {
    for (const tr of visible) highlightRow(tr, q);
    applyZebraByGroup();
  });
}

function debounceApply() {
  clearTimeout(t);
  t = setTimeout(applySearch, DEBOUNCE);
}

// один input handler: и дебаунс, и clear button
input.addEventListener("input", () => {
  toggleClear();
  debounceApply();
});

clearBtn.addEventListener("click", () => {
  input.value = "";
  toggleClear();
  applySearch(); // без setTimeout, сразу
  input.focus();
});

input.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && input.value) {
    e.preventDefault();
    clearBtn.click();
  }
});

toggleClear();
applyZebraByGroup();

// ---------- In-stock filter (optimized) ----------
const sw = document.getElementById("filter-in-stock");
if (!sw) return;

function setGhostRow(tr, on) {
  tr.classList.toggle("ghost-row", on);
  const tds = tr.querySelectorAll("td");
  for (const td of tds) {
    if (td.classList.contains("photo-cell")) td.classList.remove("ghost-cell");
    else td.classList.toggle("ghost-cell", on);
  }
}

function isInStock(tr) {
  const c = tr.querySelector(".cell-availability");
  return !!c && c.textContent.trim() === "В наличии";
}

const cellsByRow = new Map();
function clearRowHighlight(tr) {
  const tds = cellsByRow.get(tr) || [];
  for (const td of tds) {
      const base = origHtml.get(td);
      if (base != null && td.innerHTML !== base) td.innerHTML = base;
  }
}

function applyStockFilter() {
  const only = sw.checked;

  for (const group of groups) {
    if (winterActive && group.dataset.winter !== "1") {
      group.style.display = "none";
      // на всякий — скрыть строки/сброс подсветки
      group.querySelectorAll("tr").forEach(r => {
        r.style.display = "none";
        setGhostRow(r, false);
        clearRowHighlight(r);
      });
      continue;
    }
    const groupRows = [...group.querySelectorAll("tr")];
    if (!groupRows.length) continue;

    const firstRow = groupRows[0];
    const photoCell = firstRow?.querySelector(".photo-cell") || null;

    if (!only) {
      group.style.display = "";
      for (const r of groupRows) {
        r.style.display = "";
        setGhostRow(r, false);
      }
      if (photoCell) photoCell.rowSpan = groupRows.length;
      continue;
    }

    // один проход: считаем видимые, прячем сразу
    let visibleBelow = 0;
    let hasAny = false;

    for (let i = 0; i < groupRows.length; i++) {
      const r = groupRows[i];
      const ok = isInStock(r);

      if (i === 0) {
        // первая строка всегда видима ради фото
        r.style.display = "";
        setGhostRow(r, !ok);
        if (ok) hasAny = true;
      } else {
        r.style.display = ok ? "" : "none";
        setGhostRow(r, false);
        if (ok) {
          visibleBelow++;
          hasAny = true;
        }
      }
    }

    if (!hasAny) {
      group.style.display = "none";
    } else {
      group.style.display = "";
      if (photoCell) photoCell.rowSpan = Math.max(1 + visibleBelow, 1);
    }
  }

  applyZebraByGroup();
}

sw.addEventListener("change", applyStockFilter);
applyStockFilter();

const snowBtn = document.querySelector(".snow-btn"); // как у тебя
let winterActive = !!snowBtn?.classList.contains("active");
document.body.classList.toggle("snow-mode", winterActive);

snowBtn?.setAttribute("aria-pressed", String(winterActive));

snowBtn?.addEventListener("click", () => {
  winterActive = !winterActive;
  snowBtn.classList.toggle("active", winterActive);
  snowBtn.setAttribute("aria-pressed", String(winterActive));
  document.body.classList.toggle("snow-mode", winterActive);

  applyStockFilter(); // ВАЖНО: одна точка правды
});